var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',{staticClass:"is-size-7"},[_vm._v("Libre  "),_c('VbSwitch',{attrs:{"type":"dark","size":"medium","disabled":"disabled"},model:{value:(_vm.checado),callback:function ($$v) {_vm.checado=$$v},expression:"checado"}}),_vm._v("  Operando")],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-750ebae9","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/estaciones_Componentes/layouts/switch_llenaderas.vue
// module id = 2792
// module chunks = 0